import { useState } from 'react';
import { UserSummary } from '../../queries/users';
import { UserFeaturesModal } from './UserFeaturesModal';
import { UserActivityPanel } from '../Dashboard/UserActivityPanel';

interface UserActivityTabProps {
  user: UserSummary;
}

const DATE_FORMATTER = new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: 'short', year: 'numeric' });

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <p className="text-xs text-muted-foreground">{label}</p>
      <p className="font-medium">{value}</p>
    </div>
  );
}

export function UserActivityTab({ user }: UserActivityTabProps) {
  const [showFeaturesModal, setShowFeaturesModal] = useState(false);

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-border bg-card p-4">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="font-semibold">Account</h3>
          <button
            type="button"
            onClick={() => setShowFeaturesModal(true)}
            className="rounded-md border border-input px-3 py-1.5 text-sm font-medium hover:bg-accent"
          >
            Manage Features
          </button>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
          <Field label="Subscription" value={user.subscription_level} />
          <Field label="Marketing Consent" value={user.marketing_consent ? 'Yes' : 'No'} />
          <Field label="Weekly Tips" value={user.weekly_tips_subscribed ? 'Yes' : 'No'} />
          <Field label="Registered" value={DATE_FORMATTER.format(new Date(user.created_at))} />
          <Field label="Last Updated" value={DATE_FORMATTER.format(new Date(user.updated_at))} />
          {user.marketing_consent_date && (
            <Field label="Consent Given" value={DATE_FORMATTER.format(new Date(user.marketing_consent_date))} />
          )}
        </div>
      </div>

      <div className="rounded-lg border border-border bg-card p-4">
        <h3 className="mb-3 font-semibold">User Activity</h3>
        {/* user_activity_logs.user_id is the numeric users.id, not cognito_id — the
            activity queries match on that, so this must be the numeric id. */}
        <UserActivityPanel userIdentifier={String(user.id)} />
      </div>

      {showFeaturesModal && (
        <UserFeaturesModal
          userId={String(user.id)}
          userName={[user.first_name, user.last_name].filter(Boolean).join(' ') || `User ${user.id}`}
          onClose={() => setShowFeaturesModal(false)}
        />
      )}
    </div>
  );
}
